export interface ConnectionEntry {
  id: string;
  type: "sse" | "ws";
  url: string;
  readyState: number;
  openedAt: number;
  closedAt?: number;
  errorCount: number;
  messageCount: number;
}

export type ConnectionsListener = () => void;

export const ReadyStateLabel: Record<number, string> = {
  0: "Connecting",
  1: "Open",
  2: "Closing",
  3: "Closed",
};
